import b_ from "b_";
// extracted by mini-css-extract-plugin
export default {"opacity":"styles_opacity__SS-9q","on":"styles_on__Fy5QR","slide":"styles_slide__ZKQ5g","left":"styles_left__7DIYW","right":"styles_right__tZMla","top":"styles_top__BY2EX","bottom":"styles_bottom__vTXWr"};
export const b = b_.with('opacity');